import { Wizard } from "../wizard";
import { AsYouType } from 'libphonenumber-js'

const asYouType = new AsYouType('US');
$.validator.addMethod("phoneNumber", (value, element) => {
  asYouType.reset();
  const formatted = asYouType.input(value);
  if (asYouType.isValid()) {
    element.value = formatted;
    return true;
  }
  return false;
});

let form = $("#registration-form").validate({
  onkeyup: false,
  onfocusout: function(element) {
    this.element(element);
  },
  rules: {
    email: {
      email: true,
      remote: {
        url: "/helper/email-unique",
        type: "post",
        headers: {
          "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        data: {
          name: function () {
            return $("#email").val();
          },
        },
      },
    },
    "company[corporate_phone]": 'phoneNumber',
    "company[postal_code]": {
      regex: "^([0-9]{5})(?:[-s]*([0-9]{4}))?$",
    },
    password: {
      required: true,
      minlength: 12,
      containsUppercaseLetter: true,
      containsLowercaseLetter: true,
      containsNumber: true,
      containsSymbol: true,
      notContainsEmail: true,
    },
    password_confirmation: {
      equalTo: "#password",
    },
  },
  messages: {
    email: {
      remote: "Email address has been taken, please choose another email address.",
    },
    "company[corporate_phone]": {
      phoneNumber: "Phone number is invalid",
    },
    "company[postal_code]": {
      regex: "Zip code is invalid.",
    },
    highlight: function (element, errorClass) {
      $(element).removeClass(errorClass);
    },
  },
  errorClass: "error-class",
  validClass: "valid-class",
  errorElement: "div",
  errorPlacement: function (error, element) {
    if (element.parent(".input-group").length) {
      error.insertAfter(element.parent());
    } else {
      error.insertAfter(element);
    }
  },
  submitHandler: async function (form) {
    form.submit();
  },
});

const wizard = new Wizard("#register-wizard", {
  progress: true,
  validate: true,
  validator: form,
});

$(".toggle-password").on("click", function () {
  let currentType = $(this).siblings().first().prop("type");
  let icon = currentType == "text" ? "eye-closed" : "eye";

  $(this)
    .siblings()
    .first()
    .prop("type", currentType == "text" ? "password" : "text");

  $(this)
    .find("img")
    .first()
    .prop("src", "/images/icons/" + icon + ".svg");
});
